import React from 'react';
import badge from '../../../../images/boomer.png'
import styles from './BoomBassadors.module.scss'
import { Tooltip } from 'react-tippy';

const BoomBassadorBadges = (props) => {
    return (
        <div className={styles.sidebadges}>
            <h1 className={styles.boombassadorTitle}>
                Boombassador Badges
            </h1>

            <div className={styles.badgeProgress}>
                <div className={styles.track}>
                    <div
                        className={styles.trackFill}
                        style={{
                            width: `${props.progress}%`,
                        }}
                    />
                    <span
                        className={styles.divider}
                        style={{
                            left: '25%',
                        }}
                    />
                    <span
                        className={styles.divider}
                        style={{
                            left: '50%',
                        }}
                    />
                    <span
                        className={styles.divider}
                        style={{
                            left: '75%',
                        }}
                    />
                </div>

                <div className={styles.badges}>
                    <div
                        className={`${styles.badge} ${
                            props.progress >= 25 ? styles.active : ''
                        }`}
                        style={{
                            left: '25%',
                        }}
                    >
                        <Tooltip title="25" size="big">
                            <div className={`${styles.token} ${styles.bronze}`}>
                                <img
                                    className={styles.tokenImg}
                                    src={badge}
                                    alt=''
                                />
                            </div>
                        </Tooltip>
                    </div>

                    <div
                        className={`${styles.badge} ${
                            props.progress >= 50 ? styles.active : ''
                        }`}
                        style={{
                            left: '50%',
                        }}
                    >
                        <Tooltip title="50" size="big">
                            <div className={`${styles.token} ${styles.silver}`}>
                                <img
                                    className={styles.tokenImg}
                                    src={badge}
                                    alt=''
                                />
                            </div>
                        </Tooltip>
                    </div>

                    <div
                        className={`${styles.badge} ${
                            props.progress >= 75 ? styles.active : ''
                        }`}
                        style={{
                            left: '75%',
                        }}
                    >
                        <Tooltip title="75" size="big">
                            <div className={`${styles.token} ${styles.gold}`}>
                                <img
                                    className={styles.tokenImg}
                                    src={badge}
                                    alt=''
                                />
                            </div>
                        </Tooltip>
                    </div>

                    <div
                        className={`${styles.badge} ${
                            props.progress >= 100 ? styles.active : ''
                        }`}
                        style={{
                            left: '100%',
                        }}
                    >
                        <Tooltip title="100" size="big">
                            <div className={`${styles.token} ${styles.diamond}`}>
                                <img
                                    className={styles.tokenImg}
                                    src={badge}
                                    alt=''
                                />
                            </div>
                        </Tooltip>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BoomBassadorBadges;